module.exports = __webpack_public_path__ + "zoom_in-v1-e03ea257.svg";